import { Box, Tab, Tabs } from "@mui/material"
import { IVideoLessionProgramSubjectsProps, TabPanelProps } from "./VideoLessionFileModels";
import React from "react";
import { VideoLessionProgramFiles } from "./videoLessionProgramFiles";
function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}
export const VideoLessionProgramSubjects = (props: IVideoLessionProgramSubjectsProps) => {
    const [value, setValue] = React.useState(0);
    const { videoLessionProgramFilter, videoLessionProgramFiles, videoLessionProgramProps, handleFileUpload, handleDelete } = props;
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const getSubjectVideoLessionFiles = (subjectId: number) => {
        return videoLessionProgramFiles.filter(i => i.subjectId === subjectId);
    }
    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'grey.50', px: 3 }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        minHeight: 48,
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: 500,
                            fontSize: '0.875rem',
                            minHeight: 48,
                            px: 2.5,
                            color: 'text.secondary',
                            '&.Mui-selected': { fontWeight: 700, color: 'primary.main' },
                        },
                        '& .MuiTabs-indicator': { height: 3, borderRadius: '3px 3px 0 0' },
                    }}
                >
                    {videoLessionProgramFilter.subjects.map((subject, index) => (
                        <Tab key={index} label={subject.subjectName} {...a11yProps(index)} />
                    ))}
                </Tabs>
            </Box>
            {videoLessionProgramFilter.subjects.map((subject, index) => (
                <CustomTabPanel key={index} value={value} index={index}>
                    <VideoLessionProgramFiles
                        programFiles={getSubjectVideoLessionFiles(subject.subjectId)}
                        fileUploadIsInProgress={false}
                        handleFileUpload={handleFileUpload}
                        handleDelete={handleDelete}
                        videoLessionProgramProps={videoLessionProgramProps}
                        subjectId={subject.subjectId}
                    />
                </CustomTabPanel>
            ))}
        </>
    )
}